export default __webpack_public_path__ + "static/media/nodejs.adf3246d.svg";